import styled from 'styled-components'
import tw from 'twin.macro'

const StyledCustomInput = styled.div.attrs({
  className: "custom-input"
})`
  & {
    ${tw`flex flex-col items-baseline`}
    
    &.custom-input--error {

      .custom-input__span {
        transform: translateY(0);
        opacity: 1;
      }
    }

    .custom-input__span {
      ${tw`bg-red-400 inline-block p-2 mt-2 rounded-full text-xs`}
      will-change: transform, opacity;

      transform: translateY(-100%);
      opacity: 0;
      transition: transform .3s .25s ease-out,
                  opacity .3s .25s ease-out;
    }
  }

`

export default StyledCustomInput